import React, { act } from 'react';
import classes from './PatientsShortDetailCard.module.css';
import { CurrencyIcon } from '../../../Assets/icons';
import CommonCard from '../CommonCard';
import LabeledText from '../LabeledText';
import clsx from 'clsx';
import moment from 'moment';
import { formatPhoneNumber, numberFormatter } from '../../../Helpers';
const PatientShortDetailCard = ({
  className,
  onClick,
  name,
  age,
  gender,
  cellNumber,
  appointmentTime,
  isAppointment,
  isWalkInPatient,
  isFollowupPatient,
  schedule = false,
  lastVisit,
  isDeleted,
  amount,
  ...rest
}) => {
  console.log('isFollowUpPatient', isFollowupPatient);
  let patientType = null;
  if (isDeleted) {
    patientType = <p className={classes.canceled}>Cancelled</p>;
  } else if (isAppointment) {
    patientType = <p className={classes.appointment}>Appointment</p>;
  } else if (isWalkInPatient) {
    patientType = <p className={classes.walkIn}>Walk In Patient</p>;
  } else if (isFollowupPatient) {
    patientType = <p className={classes.followUp}>Follow Up</p>;
  }
  return (
    <CommonCard
      className={clsx(className, classes.cardWrapper)}
      onClick={() => {
        if (typeof onClick === 'function') {
          onClick();
        }
      }}
      {...rest}>
      <div className={clsx(classes.mainInfo)}>
        <h2 className={classes.title}>{name}</h2>
        {/* vi stand for value indicator */}
        {!schedule && (
          <div className={classes.viWrapper}>
            <span>
              <CurrencyIcon color="var(--primary-color)" />
            </span>
            <span className={classes.vi}>Rs. {numberFormatter(amount)}</span>
          </div>
        )}
      </div>

      {/* design for patient visit and type such as (wal k in ) */}
      <ul className={classes.shortDetailWrapper}>
        {/* patient visit detail style (appointement and lastvisit) */}
        {!schedule && (
          <LabeledText
            Tag="li"
            label={'Last Visit: '}
            value={lastVisit ? moment(lastVisit).format('DD MMM YYYY') : 0}
          />
        )}
        {schedule && (
          <LabeledText
            Tag="li"
            label={'Appointment Time: '}
            value={appointmentTime && moment(appointmentTime).format('hh:mm A')}
          />
        )}
        {/* visit type style such as (Walk In Patient ,Appointment Follow up) */}
        <li className={classes.typeIndicatorWrapper}>
          {/* {isAppointment ? (
            <p className={classes.appointment}>Appointment</p>
          ) : isWalkInPatient ? (
            <p className={classes.walkIn}>Walk In Patient</p>
          ) : (
            <p className={classes.followUp}>Follow Up</p>
          )} */}
          {patientType}{' '}
        </li>
      </ul>
      {/* card for patient personal information */}
      <ul className={classes.shortDetailWrapper}>
        <LabeledText Tag="li" label={'Phone Number: '} value={formatPhoneNumber(cellNumber)} />
        {/* personal Information (such as gender and age) */}
        <LabeledText Tag="li" label={'Age/Gender'} value={`${age}, ${gender}`} />
      </ul>
    </CommonCard>
  );
};

export default PatientShortDetailCard;
